
import React from 'react';
import ReactDOM from 'react-dom';
import Relay from 'react-relay';
import useRelay from 'react-router-relay';

import { Router,hashHistory,applyRouterMiddleware} from 'react-router';

import routes from './routes';

import Config from './Config';
import NetworkLayer from './NetworkLayer';
import RelayStore from './RelayStore';

if (localStorage.getItem('authToken')) {
  const networkLayer = new NetworkLayer(
    Config.backendUrl, {
      headers: {
        token: localStorage.getItem('authToken'),
      },
  });
  networkLayer.setToken(localStorage.getItem('authToken'));
  RelayStore.reset(networkLayer);
}
else {
  const networkLayer = new NetworkLayer(Config.backendUrl, {});
  RelayStore.reset(networkLayer);
}

ReactDOM.render(
  <Router
    history={hashHistory}
    routes={routes}
    render={applyRouterMiddleware(useRelay)}
    environment={RelayStore._env}
  />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js